module.exports = {
  "id": "understory tutorial 4",
  "startingScene": 0,
  "title": "4: Looks",
  "thumbnail": "/provision/projects/understory tutorial 4/tutorial 4 image.png",
  "category": "tutorial",
  "toolbar": {
    "glitches": [],
    "parts": []
  },
  "project_file": "understory tutorial 4.gbp",
  "tutorial_scripts": [
    "level1.json"
  ]
}
;